export default "__VITE_ASSET__c6565e6d__"